module.exports = __webpack_public_path__ + "img/1_020.04c2d4ed.jpg";